<template>
    <div>
        <!-- 页面导航栏 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-document"></i>结算方式管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 主容器 -->
        <div class="container">
            <!-- 搜索区域 -->
            <div class="handle-box">
                <el-input v-model="name" placeholder="请输入结算方式编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button style="float:right" type="primary" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}
                </el-button>

            </div>
            <!-- 数据表格 -->
            <el-table :data="tableData" border stripe class="table" ref="multipleTable"
                      header-cell-class-name="table-header">
                <!-- 表格列定义 -->
                <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
                <el-table-column prop="bill_mode_no" label="结算方式编号" align="center"></el-table-column>
                <el-table-column prop="bill_mode_name" label="结算方式名称" align="center"></el-table-column>
                <el-table-column prop="type" label="类型" align="center">
                    <template slot-scope="scope">
                        <el-tag
                            :type="getTypeTagType(scope.row.type)"
                            size="mini"
                        >
                            {{ getTypeName(scope.row.type) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="mode" label="方式" align="center">
                    <template slot-scope="scope">
                        <el-tag
                            :type="getModeTagType(scope.row.mode)"
                            size="mini"
                        >
                            {{ getModeName(scope.row.mode) }}
                        </el-tag>
                    </template>
                </el-table-column>

                <!-- 启用状态列 -->
                <el-table-column label="启用" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                                   @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <!-- 默认状态列 -->
                <el-table-column label="默认" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isdefault" :active-value="1" :inactive-value="0"
                                   @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column prop="remark" :label="$t('common.remark')" align="center"></el-table-column>

                <!-- 操作列（仅允许编辑时显示） -->
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
                                   v-if="perData.allow_edit == 1">{{ $t('common.edit') }}
                        </el-button>
                        <el-button type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">
                            {{ $t('common.delete') }}
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑对话框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-form ref="form" :model="editForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="结算方式编号">
                    <el-input v-model="editForm.bill_mode_no" disabled></el-input>
                </el-form-item>
                <el-form-item label="结算方式名称">
                    <el-input v-model="editForm.bill_mode_name"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-radio v-model="editForm.type" :label=1>回购/入库</el-radio>
                    <el-radio v-model="editForm.type" :label=2>销售/出库</el-radio>
                </el-form-item>
                <el-form-item label="方式">
                    <el-radio v-model="editForm.mode" :label=0>结价</el-radio>
                    <el-radio v-model="editForm.mode" :label=1>欠料</el-radio>
                    <el-radio v-model="editForm.mode" :label=-1>存料</el-radio>
                    <el-radio v-model="editForm.mode" :label=2>附加项</el-radio>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="editForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="editFormData">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 新增对话框 -->
        <el-dialog :title="$t('common.add')" :visible.sync="addDialogVisible" width="30%" :before-close="handleAddClose">
            <el-form ref="addForm" :model="addForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="结算方式编号">
                    <el-input v-model="addForm.bill_mode_no"></el-input>
                </el-form-item>
                <el-form-item label="结算方式名称">
                    <el-input v-model="addForm.bill_mode_name"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                    <el-radio v-model="addForm.type" :label=1>回购/入库</el-radio>
                    <el-radio v-model="addForm.type" :label=2>销售/出库</el-radio>
                </el-form-item>
                <el-form-item label="方式">
                    <el-radio v-model="addForm.mode" :label=0>结价</el-radio>
                    <el-radio v-model="addForm.mode" :label=1>欠料</el-radio>
                    <el-radio v-model="addForm.mode" :label=-1>存料</el-radio>
                    <el-radio v-model="addForm.mode" :label=2>附加项</el-radio>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="addForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleAddClose">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 导入 API 接口
import {
    apiGetBillModeStatusList,
    apiCurrentPermisson,
    apiBillModeManagePull,
    apiAddBillModeData,
    apiUpdateBillModeStatus,
    apiUpdateBillModeData,
    apiDeleteBillModeData
} from '@/request/api';

export default {
    name: 'BillModeManage',
    data() {
        return {
            addForm: {},
            editForm: {},
            dialogVisible: false,
            addDialogVisible: false,
            pullData: [],
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            pageTotal: 0,
            systemSet: JSON.parse(localStorage.getItem('systemSet'))
        };
    },
    mounted() {
        // 组件挂载时加载数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    activated() {
        // keep-alive 缓存组件激活时刷新数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    methods: {
        // 获取类型标签的颜色类型
        getTypeTagType(type) {
            switch (type) {
                case 1: return 'primary';   // 回购/入库 - 蓝色
                case 2: return 'warning';   // 销售/出库 - 橙色
                default: return 'info';     // 其他 - 灰色
            }
        },
        // 获取类型名称
        getTypeName(type) {
            switch (type) {
                case 1: return '回购/入库';
                case 2: return '销售/出库';
                default: return '';
            }
        },
        // 获取方式标签的颜色类型
        getModeTagType(type) {
            switch (type) {
                case 0: return 'primary';   // 结价 - 蓝色
                case 1: return 'warning';   // 欠料 - 橙色
                case -1: return 'success';  // 存料 - 绿色
                default: return 'info';     // 其他 - 灰色
            }
        },
        // 获取方式名称
        getModeName(type) {
            switch (type) {
                case 0: return '结价';
                case 1: return '欠料';
                case -1: return '存料';
                case 2: return '附加项';
                default: return '';
            }
        },
        getPull() {
            apiBillModeManagePull().then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        // 编辑按钮点击事件
        handleEdit(row) {
            this.dialogVisible = true;
            // 创建 row 的深拷贝，避免直接引用原始数据
            this.editForm = JSON.parse(JSON.stringify(row));
        },
        // 提交编辑表单
        editFormData() {
            apiUpdateBillModeData(this.editForm).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg); // 成功提示
                    this.getData(); // 刷新表格数据
                    this.handleClose(); // 关闭对话框
                } else {
                    this.$message.error(res.data.info);// 失败提示
                }
            });
        },
        // 关闭编辑对话框
        handleClose() {
            this.editForm = {};// 清空表单数据
            this.dialogVisible = false; // 隐藏对话框
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addDialogVisible = true;
            this.addForm = {};
        },
        saveAdd() {
            apiAddBillModeData(this.addForm).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '添加成功', type: 'success' });
                    this.addDialogVisible = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleAddClose() {
            this.addForm = {};
            this.addDialogVisible = false;
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let data = {
                        bill_mode_no: row.bill_mode_no // 结算方式编号
                    };
                    apiDeleteBillModeData(data).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {
                });
        },

        // 锁定状态切换事件
        tableDatastates(row) {
            let data = {
                bill_mode_no: row.bill_mode_no, // 结算方式编号
                islock: row.islock, // 锁定状态（1=锁定，0=解锁）
                status: row.status, // 启用状态（1=启用，0=停用）
                mode: row.mode, // 方式（1=启用，0=停用）
                type: row.type, // 类型（1=启用，0=停用）
                isdefault: row.isdefault // 默认状态（1=是，0=否）
            };
            apiUpdateBillModeStatus(data).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg);// 成功提示
                } else {
                    this.$message.error(res.data.info); // 失败提示
                }
                this.getData(); // 刷新表格数据
            });
        },
        // 获取列表信息
        getData() {
            this.$load.show(); // 显示加载动画
            apiGetBillModeStatusList({
                page: this.pageIndex, // 当前页码
                page_size: this.pageSize, // 每页数量
                seek: this.name// 搜索关键字
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;// 赋值表格数据
                    this.pageTotal = res.data.count;// 赋值总数据量
                } else {
                    this.$message.error(res.data.info);// 错误提示
                }
            });
            this.$load.close(); // 关闭加载动画
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '191' // 权限ID（需根据实际ID调整）
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;// 赋值权限数据
                } else {
                    this.$message.error(res.msg); // 错误提示
                }
            });
        },
        // 搜索按钮点击事件
        handleSearch() {
            this.pageIndex = 1;// 重置为第一页
            this.getData();// 重新加载数据
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val; // 更新当前页码
            this.getData();// 重新加载数据
        },
        pageSizeChange(val) {
            this.pageSize = val; // 更新每页数量
            this.getData(); // 重新加载数据
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}

.el-table th {
    background: #ecf5ff !important;
}

.el-dialog {
    width: 40%;
}

@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }

    .el-message-box {
        width: 100%;
    }

    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
